export default function (to, from, savedPosition) {
  let position
  let delay
  let timeoutId = null

  const isProductRoute = name => {
    if (!name) return false
    return /^produit-slug(___[a-z]{2})?$/.test(name)
  }

  if (to.hash && /^#[A-Za-z][\w-]*$/.test(to.hash)) {
    if (to.path === from.path) {
      return { selector: to.hash }
    }
    return new Promise(resolve => {
      let tries = 0
      const scrollWhenReady = () => {
        if (document.querySelector(to.hash)) {
          resolve({ selector: to.hash })
        } else if (++tries > 60) {
          resolve({ x: 0, y: 0 })
        } else {
          setTimeout(scrollWhenReady, 50)
        }
      }
      scrollWhenReady()
    })
  } else if (savedPosition && isProductRoute(from.name)) {
    delay = process.env.DEV === 'true' ? 2500 : 1500
    position = savedPosition
  } else {
    delay = 50
    position = { x: 0, y: 0 }
  }

  if (timeoutId !== null) {
    clearTimeout(timeoutId)
  }

  return new Promise(resolve => {
    timeoutId = setTimeout(() => {
      timeoutId = null
      resolve(position)
    }, delay)
  })
}
